import { createSlice } from '@reduxjs/toolkit'


const slice = createSlice({
	name: 'layout',
	initialState:{
		// showBodyContentDrawer:window.innerWidth > 800,
		showBodyContentDrawer:false,
		//these are the visible/hidden client feature settings
		userClientFeatures:[]
	},
	reducers: {
		updateLayout:(state,action)=>{
			const {payload} = action
			console.log('PAYLOAD: ', action)
			Object.keys(payload).map((k)=>{
				state[k] = payload[k]
			})
		},
		setUserClientFeatures:(state,action)=>{
			state.userClientFeatures = action.payload
		}
	},

})

export const {
	setUserClientFeatures,
	updateLayout
} = slice.actions

export default slice.reducer